import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import DashboardNavbar from './components/navbar/index';
import DashboardSidebar from './components/sidebar/index';


const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 70;

const RootStyle = styled('div')({
	display: 'flex',
	minHeight: '100%',
	overflow: 'hidden',
});

const MainStyle = styled('div')(({ theme }) => ({
	flexGrow: 1,
	overflow: 'hidden',
	minHeight: '100%',
	paddingTop: APP_BAR_MOBILE + 24,
	paddingBottom: theme.spacing(1),
	backgroundColor: '#f5f5f5',
	[theme.breakpoints.up('lg')]: {
		paddingTop: APP_BAR_DESKTOP + 10,
		paddingLeft: theme.spacing(1),
		paddingRight: theme.spacing(1),
	},
}));

const DashboardLayout = () => {
	const [open, setOpen] = useState(false);
	return (
		<RootStyle>
			<DashboardNavbar onOpenSidebar={() => setOpen(true)} />
			<DashboardSidebar
				isOpenSidebar={open}
				onCloseSidebar={() => setOpen(false)}
			/>
			<MainStyle>
				<Outlet />
			</MainStyle>
		</RootStyle>
	);
};
export default DashboardLayout;
